import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { formatDays } from "@/lib/format";
import type { PtoBalanceQuarter } from "@/lib/pto-balance";

interface QuarterlyBalanceCardProps {
  quarter: PtoBalanceQuarter;
}

export function QuarterlyBalanceCard({ quarter }: QuarterlyBalanceCardProps) {
  const percentUsed =
    quarter.accruedHours > 0 ? (quarter.usedHours / quarter.accruedHours) * 100 : 0;
  const clampedPercent = Math.min(100, Math.max(0, percentUsed));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">This Quarter · {quarter.label}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Progress value={clampedPercent} />
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">
            {formatDays(quarter.remainingDays)} remaining
          </span>
          <span className="text-muted-foreground">{formatDays(quarter.usedDays)} used</span>
        </div>
      </CardContent>
    </Card>
  );
}
